import { UPDATE_ONSTREET_COMMON_MARKER_DATA } from "./onstreetCommonMarkerDataReducer"

export const updateOnstreetCommonMarkerData = (info) => ({
    type: UPDATE_ONSTREET_COMMON_MARKER_DATA,
    payload: info
})